module.exports = __webpack_public_path__ + "static/media/offres_auto_1.45a8b062.png";